import { render, staticRenderFns } from "./Npa.vue?vue&type=template&id=d8706c1a"
import script from "./Npa.vue?vue&type=script&lang=js"
export * from "./Npa.vue?vue&type=script&lang=js"
import style0 from "./Npa.vue?vue&type=style&index=0&id=d8706c1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports